import styled from "styled-components";

const S = {
    Wrapper: styled.div`
        display: grid;
        grid-template-columns: 1fr 1.5fr;
        gap: 60px;
        width: 100%;
        max-width: 1400px;
        margin: 0 auto;
        padding: 80px 40px;
        background: #fff;
        
        @media (max-width: 1024px) {
            grid-template-columns: 1fr;
            padding: 60px 20px;
            gap: 40px;
        }
    `,
    Sol: styled.div`
        display: flex;
        flex-direction: column;
        justify-content: center;

        .content-link {
            text-decoration: none;
            color: #1a2b34;
            display: flex;
            flex-direction: column;
            gap: 20px;

            .title {
                font-size: 3.5em;
                line-height: 1.1;
                margin: 0;
                font-weight: 300;
                color: #1a2b34;
                letter-spacing: -1px;

                @media (max-width: 768px) {
                    font-size: 2.5em;
                }

                b {
                    font-weight: 800;
                    display: block;
                    background: linear-gradient(135deg, #00A9C4 0%, #00798c 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
            }

            .desc {
                font-size: 1.1em;
                line-height: 1.6;
                color: #4a5568;
                margin: 0;
            }

            .minimal-btn {
                display: inline-flex;
                align-items: center;
                gap: 8px;
                background: transparent;
                color: #00A9C4;
                padding: 0;
                border: none;
                font-size: 1.1em;
                font-weight: 600;
                cursor: pointer;
                transition: all 0.3s ease;
                align-self: flex-start;
                margin-top: 10px;
                position: relative;

                svg {
                    width: 24px;
                    height: 24px;
                    transition: transform 0.3s ease;
                    fill: #00A9C4;
                }
                
                &::after {
                    content: '';
                    position: absolute;
                    bottom: -4px;
                    left: 0;
                    width: 0%;
                    height: 2px;
                    background: #00A9C4;
                    transition: width 0.3s ease;
                }

                &:hover {
                    color: #00798c;

                    svg {
                        transform: translateX(5px);
                        fill: #00798c;
                    }

                    &::after {
                        width: 100%;
                        background: #00798c;
                    }
                }
            }
        }
    `,
    Sag: styled.div`
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;

        .bento-grid {
            display: grid;
            grid-template-columns: 2fr 1.2fr;
            grid-template-rows: repeat(2, 1fr);
            gap: 20px;
            width: 100%;
            height: 500px;
            
            @media (max-width: 768px) {
                height: 400px;
            }
        }

        .bento-card {
            border-radius: 20px;
            overflow: hidden;
            position: relative;
            background: #f1f1f1;
            box-shadow: 0 10px 30px rgba(0,0,0,0.08);

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                transition: transform 0.5s ease;
            }

            &:hover img {
                transform: scale(1.05);
            }
        }

        .hero {
            grid-column: 1 / 2;
            grid-row: 1 / 3;
        }

        .top-right {
            grid-column: 2 / 3;
            grid-row: 1 / 2;
        }

        .bottom-right {
            grid-column: 2 / 3;
            grid-row: 2 / 3;
        }
    `
};

export default S;